<script>
  import ArtPanel from '../../components/Design/ArtPanel.svelte';
  import FontPanel from '../../components/Design/FontPanel.svelte';
  import NamesPanel from '../../components/Design/NamesPanel.svelte';
  import UploadPanel from '../../components/Design/UploadPanel.svelte';

  import { isMobile, designTabActive } from '../../stores/Designer.js';

  import { removeTransformer } from '../../routes/design/[productSlug]/_design-functions.js';
  import { environment } from '../../environment/environment.js';

  import { activeElement, editingElement } from '../../stores/Designer.js';

  const printPricing = environment.PRINT_PRICING;

  export let addToKonva;
  export let updateInKonva;
  export let icons;
  export let currentTab; // a store
  export let konvaStage;
  export let segment;

  const navIcons = {
    text: `<svg id="textNav" xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 50 50"><polygon points="16.52 14.53 23.03 14.53 23.03 35.52 20.75 35.52 20.75 38.38 29.2 38.38 29.2 35.52 26.97 35.52 26.97 14.53 33.57 14.53 33.57 17.98 36.15 17.98 36.15 11.57 13.9 11.57 13.9 17.98 16.52 17.98 16.52 14.53" fill="currentColor"/><path d="M25,0C11.19,0,0,11.19,0,25s11.19,25,25,25,25-11.19,25-25S38.81,0,25,0Zm13.87,20.65h-7.53v-3.4h-1.6v15.45h2.33v8.5h-14.18v-8.5h2.33v-15.45h-1.41v3.4h-7.67V8.8h27.73v11.85Z" fill="currentColor"/></svg>`,
    art: `<svg id="artNav" xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 50 50"><path d="M19.89,21.89c1.7,0,3.08-1.38,3.08-3.08s-1.38-3.08-3.08-3.08-3.08,1.38-3.08,3.08,1.38,3.08,3.08,3.08Z" fill="currentColor"/><path d="M31.47,22.04c-.69-1.01-2.19-1-2.87,.02l-7.24,10.87-2.9-5.21c-.64-1.16-2.3-1.2-2.99-.07l-3.49,5.68c-.83,1.34,.14,3.07,1.72,3.07h23.78c1.62,0,2.58-1.81,1.66-3.15l-7.66-11.2Z" fill="currentColor"/><path d="M25,0C11.19,0,0,11.19,0,25s11.19,25,25,25,25-11.19,25-25S38.81,0,25,0Zm17.96,27.62v8.39c0,2.56-2.08,4.64-4.64,4.64H11.67c-2.56,0-4.64-2.08-4.64-4.64V13.99c0-2.56,2.08-4.64,4.64-4.64h26.66c2.56,0,4.64,2.08,4.64,4.64v13.63Z" fill="currentColor"/></svg>`,
    upload: `<svg id="uploadNav" xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 50 50"><path d="M25,0C11.19,0,0,11.19,0,25s11.19,25,25,25,25-11.19,25-25S38.81,0,25,0Zm2.03,37.76v5.27h-4.06v-5.27h-2.34l4.38-4.06,4.35,4.06h-2.33Zm10.59-5.44H12.38c-4.59,0-8.32-3.73-8.32-8.32s3.73-8.32,8.32-8.32c1.06,0,2.11,.2,3.09,.6,1.27-4.12,5.15-7.04,9.53-7.04s8.26,2.91,9.53,7.04c.98-.39,2.03-.6,3.09-.6,4.59,0,8.32,3.73,8.32,8.32s-3.73,8.32-8.32,8.32Z" fill="currentColor"/></svg>`,
    names: `<svg id="namesNav" xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 50 50"><path d="M25,0C11.19,0,0,11.19,0,25s11.19,25,25,25,25-11.19,25-25S38.81,0,25,0Zm9.42,14.59h.49v-3.36h-.49v-1.84h2.86v1.76h-.34v.75h.98v-.75h-.35v-1.76h2.86v1.84h-.5v3.36h.5v1.85h-2.86v-1.78h.35v-.84h-.98v.84h.34v1.78h-2.86v-1.85Zm-6.77-5.19h6.03v2.58h-1.64v-.74h-.35v3.36h.51v1.85h-3.08v-1.85h.51v-3.36h-.31v.74h-1.67v-2.58Zm-12.29,5.19h.5v-3.36h-.5v-1.84h2.42l1.25,2.16,1.28-2.16h2.4v1.84h-.49v3.36h.49v1.85h-2.92v-1.85h.49v-1.67l-.76,1.3h-.94l-.78-1.3v1.67h.52v1.85h-2.93v-1.85Zm-5.97-3.99l1.22-1.2h2.62l1.11,1.13v1.16h-1.95v-.45h-.91v.68h2.05l.9,.93v2.36l-1.26,1.24h-2.56l-1.17-1.19v-1.29h2.04v.63h.86v-1h-2.01l-.94-.97v-2.02Zm14.67,18.45l-6.55,5.86h6.55v5.7H8.55v-5.7l9.09-8.14v-2.21h-2.61v2.64h-6.48v-4.46l3.84-3.84h7.92l3.75,3.84v6.32Zm-.23-12.61v-1.85h.49v-3.36h-.49v-1.84h3.07v1.84h-.48v3.36h.48v1.85h-3.07Zm17.62,11.24l-.98,1.01,.98,.94v7.17l-3.84,3.81h-7.95l-3.78-3.81v-5.15h6.45v3.26h2.61v-3.62h-1.95v-4.95h1.95v-1.95h-2.61v1.95h-6.03v-3.97l3.45-3.49h7.85l3.84,3.84v4.95Z" fill="currentColor"/></svg>`,
  };

  const tabs = [
    {
      name: 'text',
      src: 'text',
    },
    {
      name: 'art',
      src: 'art',
    },
    {
      name: 'upload',
      src: 'upload',
    },
    {
      name: 'names & no',
      src: 'names',
    },
  ];

  const category = {
    text: {
      name: 'text',
      price: printPricing.text / 100,
      description: 'Add Text To Your Item',
      update: 'Update Text',
    },
    art: {
      name: 'art',
      price: printPricing.art / 100,
      description: 'Customise A Template',
      update: 'Update Art',
    },
    upload: {
      name: 'upload',
      price: printPricing.upload / 100,
      description: 'Choose File to Upload',
      update: 'Update Uploaded Logo',
    },
    'names & no': {
      name: 'names & no',
      price: printPricing.namenumber / 100,
      description: 'Add Names & Numbers',
      update: 'Update Names & Numbers',
    },
  };

  function changeTab(tabName) {
    $designTabActive = true; // show tab content on mobile as we are editing
    $currentTab = tabName;
    // Do not allow change tab when editing
    if ($editingElement) {
      $editingElement = null;
      $activeElement = null;
    }
    // turn off any transformers
    removeTransformer(konvaStage);
  }
</script>

<div class="top" class:top-mobile={$isMobile} class:panel-active={$designTabActive}>
  <div class="tabs">
    {#each tabs as item}
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div class="tab" class:active={$currentTab === item.name} on:click={() => changeTab(item.name)}>
        <div class="nav-icon">{@html navIcons[item.src]}</div>
        <span>{item.name}</span>
      </div>
    {/each}
  </div>
</div>

<div class="panel-content" class:hide={$isMobile && !$designTabActive}>
  <div class="pricing">
    {#if $currentTab}
      {#if $editingElement === null}
        <h3>{category[$currentTab].description}</h3>
        <span>+{category[$currentTab].price} Extra</span>
      {:else}
        <h3>{category[$currentTab]?.update}</h3>
      {/if}
    {/if}
  </div>

  <div class="settings" id="settings">
    {#if $currentTab === 'text'}
      <FontPanel {addToKonva} {updateInKonva} {editingElement} {segment} />
    {:else if $currentTab === 'art'}
      <ArtPanel {addToKonva} {updateInKonva} {icons} {editingElement} {segment} />
    {:else if $currentTab === 'upload'}
      <UploadPanel {addToKonva} {updateInKonva} {icons} {editingElement} {segment} />
    {:else if $currentTab === 'names & no'}
      <NamesPanel {addToKonva} {updateInKonva} {editingElement} {segment} />
    {/if}
  </div>
</div>

<style>
  .top.top-mobile {
    display: block;
    position: fixed;
    bottom: 50px;
    width: 100%;
    width: 100vw;
    overflow-x: hidden;
    z-index: 80;
  }

  .top.top-mobile.panel-active {
    display: none;
  }

  .tabs {
    background-color: white;
    display: flex;
    justify-content: space-evenly;
  }

  .tab {
    text-transform: capitalize;
    color: white;
    background-color: #1c2a5c;
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    font-size: 1.2rem;
    font-weight: 600;
    padding: 0.6rem;
    border: 1px solid transparent;
    font-size: 1rem;
    border-top: solid 3px white;
    border-right: solid 1px white;
  }

  /* .tab span {
    margin-top: 0.5rem;
  } */

  .tab.active {
    color: #fe5900;
    background-color: white;
    border: 2px solid #fe5900;
    border-bottom: 3px solid white;
    position: relative;
    bottom: -3px;
    border-radius: 3px;
  }

  .panel-content {
    border: solid 2px #fe5900;
    padding-bottom: 1rem;
  }

  .panel-content.hide {
    display: none;
  }

  .pricing {
    padding: 1rem 1.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  }

  .pricing h3 {
    font-weight: 600;
    font-size: 1.8rem;
  }

  .pricing span {
    background-color: #e5f6f0;
    color: #1dab56;
    padding: 0.5rem 2rem;
    border-radius: 10rem;
    font-size: 1.4rem;
    font-weight: 600;
  }

  .settings {
    height: 100%;
    padding: 0 2.2rem;
    background-color: white;
  }
</style>
